/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import React, { useEffect, useState } from 'react';
import { ModulesStateShareInput } from '../../themes/dobbies/actions/modules-state-share-action';
import DobbiesModal from '../../themes/dobbies/views/custom-components/dobbies-modal';
import { ISearchResultModalViewProps } from './components';
import MsDyn365 from '@msdyn365-commerce/core';
import * as Msdyn365 from '@msdyn365-commerce/core';
import {
    // GridSize,
    ICategoryHierarchyViewProps,
    IRefineMenuViewProps,
    ISearchResultContainerViewProps,
    ISortByViewProps,
    ITitleViewProps
} from './dobbies-search-result-container';
import Button from 'reactstrap/lib/Button';

const SearchResultContainerView: React.FC<ISearchResultContainerViewProps> = props => {
    const {
        data: {
            category: { result: currentCategory }
        },
        SearchResultContainer,
        products,
        ProductsContainer,
        ProductSectionContainer,
        choiceSummary,
        isMobile,
        modalToggle,
        searchResultModal,
        TitleViewProps,
        refineMenu,
        categoryHierarchy,
        sortByOptions,
        CategoryNavContainer,
        RefineAndProductSectionContainer,
        errorMessage,
        FeatureSearchContainer,
        similarLookProduct,
        slots: { browse },
        // resources: { browseButtonText },
        pagination,
        refinersRef
    } = props;
    const [showModal, setShowModal] = useState(false); /* VSI-Customization -- START showModal Hook for managing state of showModal  */
    const [categoryTitle, SetCategoryTitle] = useState<string | undefined>(); // Following hook is used to store category name
    const [shouldShowMoreRefiners, setShouldShowMoreRefiners] = useState(false);
    // const { category } = props.data;
    // const categoryName = category && category.result && category.result.Name;

    useEffect(() => {
        document.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key.toLocaleLowerCase() === 'escape') {
                if (showModal) {
                    setShowModal(!showModal);
                }
            }
        });
        // Store categoryName in state data action to display it in category header
        if (categoryTitle === undefined) {
            const currentCategoryName = currentCategory && currentCategory.Name ? currentCategory.Name : '';
            props.context.actionContext.update(new ModulesStateShareInput(), { categoryName: currentCategoryName });
            SetCategoryTitle(currentCategoryName);
        }
    }, [showModal]);

    const isClickInsideElementByClassName = (className: string, event: MouseEvent): boolean => {
        let target: EventTarget | null = event.target;
        while (target && target !== document) {
            if ((target as Element).classList && (target as Element).classList.contains(className)) {
                return true;
            }
            target = (target as Node).parentNode;
        }
        return false;
    };

    useEffect(() => {
        document.body.addEventListener(
            'click',
            evt => {
                const filtersDivs = document.getElementsByClassName('new-filter__filter-section');
                if (filtersDivs && filtersDivs.length) {
                    if (!isClickInsideElementByClassName('new-filter__filter-section', evt)) {
                        if (props.onMoreFiltersClicked) {
                            props.onMoreFiltersClicked(undefined, false, true);
                        }
                    }
                }
            },
            true
        );
    }, []);
    const modalTitle = (): JSX.Element => {
        const { category } = props.data;
        const categoryName = category && category.result && category.result.Name;
        const handleShowModal = () => setShowModal(!showModal);
        return (
            <Node tag='div' className='view-all-popup-header'>
                <Node tag='span' className='title-text'>
                    {categoryName}
                </Node>
                <div className='header-close-button' onClick={handleShowModal} role='button'>
                    <i className='msc-modal__close-button' />
                </div>
            </Node>
        );
    };

    const modalFooter = (): JSX.Element => {
        const handleShowModal = () => setShowModal(!showModal);
        return <div className='close-button' role='button' onClick={handleShowModal} />;
    };
    const _modalToggle = () => {
        setShowModal(!showModal);
    };
    const renderToggle = (slotBrowse: React.ReactNode): JSX.Element | undefined => {
        // const handleShowModal = () => setShowModal(!showModal);
        return (
            <>
                <div className='category-list-mobile'>{/* <button onClick={handleShowModal}>{browseButtonText}</button> */}</div>
                <DobbiesModal
                    className='modal ms-dobbies-browse'
                    isOpen={showModal}
                    modalBodySlots={browse}
                    onModalToggle={_modalToggle}
                    modalTitle={modalTitle()}
                    modalFooter={modalFooter()}
                />
            </>
        );
    };
    const redirectUrl = props.data.products.result!.products[0].ExtensionProperties?.find(item => item.Key === 'RedirectURL');
    let shouldRedirect = false;
    if (props.data.products.result!.count === 0 && redirectUrl && redirectUrl.Value!.StringValue) {
        shouldRedirect = true;
    }
    const isSearchPage = props.context.request.query?.q;
    let hasContentBlockTitle = false;
    if (MsDyn365.isBrowser && window) {
        const categoryBanners = document.getElementsByClassName('ms-content-block category-banner');
        if (categoryBanners && categoryBanners.length) {
            const contentBlockTitleDivs = document.getElementsByClassName('ms-content-block__title');
            if (contentBlockTitleDivs && contentBlockTitleDivs.length && contentBlockTitleDivs[0].innerHTML) {
                hasContentBlockTitle = true;
            }
        }
    }

    /* VSI-Customization -- END  */
    // let collectionTitle: string | undefined = '';
    // if (props.context && props.context.request && props.context.request.query && props.context.request.query.q) {
    //     collectionTitle = `"${props.context.request.query.q}"`;
    // } else {
    //     collectionTitle = undefined;
    // }
    if (isMobile) {
        return !shouldRedirect ? (
            <Module {...SearchResultContainer}>
                {/* {!collectionTitle && <h1 className='top-title'>{categoryName} </h1>} */}
                {/* {renderOutOfStockBtn(props)} */}
                {categoryHierarchy && renderCategoryHierarchy(categoryHierarchy)}
                {(isSearchPage || !hasContentBlockTitle) && TitleViewProps && renderTitleAndProductCount(TitleViewProps, props)}
                {/* {TitleViewProps && renderTitleAndProductCount(TitleViewProps, props)} */}
                {/* VSI-Customization -- START Render Browse Module for Mobile view  */}
                {renderToggle(browse)}
                {/* VSI-Customization -- END  */}
                {modalToggle}
                {createSearchResultModal(
                    props,
                    searchResultModal,
                    refineMenu,
                    sortByOptions,
                    isMobile,
                    shouldShowMoreRefiners,
                    setShouldShowMoreRefiners
                )}
                <div className='sticky-check' ref={refinersRef}>
                    {renderRefiner(props, refineMenu, browse, false, shouldShowMoreRefiners, setShouldShowMoreRefiners)}
                </div>
                {sortByOptions && renderSort(sortByOptions)}
                {choiceSummary}
                <Node {...FeatureSearchContainer}>{similarLookProduct}</Node>
                <Node {...ProductsContainer}>
                    {errorMessage}
                    {products}
                </Node>
                {pagination}
            </Module>
        ) : (
            <></>
        );
    }
    return !shouldRedirect ? (
        <Module {...SearchResultContainer}>
            {/* {!collectionTitle && <h1 className='top-title'>{categoryName} </h1>} */}
            <Node {...CategoryNavContainer}>
                {/* {renderOutOfStockBtn(props)} */}
                {/* {outOfStock && renderOOSBtn(props)} */}
                {categoryHierarchy && renderCategoryHierarchy(categoryHierarchy)}
                {(isSearchPage || !hasContentBlockTitle) && TitleViewProps && renderTitleAndProductCount(TitleViewProps, props)}
            </Node>
            <Node {...RefineAndProductSectionContainer} ref={refinersRef}>
                <div className='sticky-check' ref={refinersRef}>
                    {renderRefiner(props, refineMenu, browse, isMobile, shouldShowMoreRefiners, setShouldShowMoreRefiners)}
                </div>
                <Node {...ProductSectionContainer}>
                    {choiceSummary}
                    {sortByOptions && renderSort(sortByOptions)}
                    <Node {...FeatureSearchContainer}>{similarLookProduct}</Node>
                    <Node {...ProductsContainer}>
                        {errorMessage}
                        {products}
                    </Node>
                    {pagination}
                </Node>
            </Node>
        </Module>
    ) : (
        <></>
    );
};

const createSearchResultModal = (
    oosProps: ISearchResultContainerViewProps,
    modalProps: ISearchResultModalViewProps,
    refineMenu: IRefineMenuViewProps,
    sortByDropDown: ISortByViewProps,
    isMobile: Boolean,
    shouldShowMoreRefiners: boolean,
    setShouldShowMoreRefiners: React.Dispatch<React.SetStateAction<boolean>>
): JSX.Element => {
    return React.cloneElement(
        modalProps.modal,
        {},
        modalProps.modalHeader,
        createModalBody(oosProps, modalProps, refineMenu, sortByDropDown, isMobile, shouldShowMoreRefiners, setShouldShowMoreRefiners),
        modalProps.modalFooter
    );
};

const createModalBody = (
    oosProps: ISearchResultContainerViewProps,
    props: ISearchResultModalViewProps,
    refineMenu: IRefineMenuViewProps,
    sortByDropDown: ISortByViewProps,
    isMobile: Boolean,
    shouldShowMoreRefiners: boolean,
    setShouldShowMoreRefiners: React.Dispatch<React.SetStateAction<boolean>>
): JSX.Element | null => {
    if (sortByDropDown) {
        return React.cloneElement(
            props.modalBody,
            {},
            renderSort(sortByDropDown),
            renderRefiner(oosProps, refineMenu, null, isMobile, shouldShowMoreRefiners, setShouldShowMoreRefiners)
        );
    }
    return null;
};

// const _getViewport = (props: ISearchResultContainerViewProps): GridSize => {
//     const { context } = props;

//     // Always render in mobile viewport on a mobile device
//     if (context.request && context.request.device && context.request.device.Type === 'Mobile') {
//         return 'xs';
//     }

//     if (MsDyn365.isBrowser && window.innerWidth) {
//         const gridSettings = context.request.gridSettings;
//         if (gridSettings) {
//             if (gridSettings.xs && window.innerWidth <= gridSettings.xs.w) {
//                 return 'xs';
//             } else if (gridSettings.sm && window.innerWidth <= gridSettings.sm.w) {
//                 return 'sm';
//             } else if (gridSettings.md && window.innerWidth <= gridSettings.md.w) {
//                 return 'md';
//             } else if (gridSettings.lg && window.innerWidth <= gridSettings.lg.w) {
//                 return 'lg';
//             }
//             return 'xl';
//         }
//     }

//     return 'xs';
// };
const _getScreenSize = (ctx: Msdyn365.ICoreContext): number => {
    if (MsDyn365.isBrowser && window && window.innerWidth) {
        const gridSettings = ctx.request.gridSettings;
        if (gridSettings) {
            if (window.innerWidth < 768) {
                // mobile
                return 1;
            } else if (window.innerWidth < 1280) {
                // iPad
                return 2;
            } else if (window.innerWidth >= 1280) {
                // Desktop
                return 3;
            } else {
                return 3;
            }
            //  else if (gridSettings.lg && window.innerWidth <= gridSettings.lg.w) {
            //     // Desktop
            //     return 3;
            // }
        }
    }

    return 3; // desktop
};
const renderRefiner = (
    viewProps: ISearchResultContainerViewProps,
    props: IRefineMenuViewProps,
    slotBrowse: React.ReactNode[] | null,
    isMobile: Boolean,
    shouldShowMoreRefiners: boolean,
    setShouldShowMoreRefiners: React.Dispatch<React.SetStateAction<boolean>>
): JSX.Element | null => {
    const { refiners, endingRefiners, RefineMenuContainer, RefinerSectionContainer } = props;
    let endingRefinersToShow = endingRefiners;
    const screenSize = _getScreenSize(viewProps.context);
    // const maxRefinersColumns = _getViewport(viewProps) !== 'xl' && _getViewport(viewProps) !== 'lg' ? 4 : 5;
    let maxRefinersColumns = screenSize === 3 ? 5 : screenSize === 2 ? 4 : 0;
    maxRefinersColumns = screenSize === 1 ? 2 : maxRefinersColumns;
    if (endingRefiners && endingRefiners?.length > maxRefinersColumns && !shouldShowMoreRefiners) {
        endingRefinersToShow = endingRefiners.slice(0, maxRefinersColumns);
    }

    if (refiners && endingRefiners) {
        console.log('Inside Refiners Category listing');
        return (
            <>
                <Node {...RefinerSectionContainer}>
                    {refiners.map((submenu, index) => (
                        <React.Fragment key={index}>{submenu}</React.Fragment>
                    ))}

                    <div className={isMobile ? '' : `refiner-add-remove`}>
                        <Node {...RefineMenuContainer}>
                            {console.log('Inside Refiners Category listing Rendering Category Listing')}
                            <div className='category-listing'>{slotBrowse && slotBrowse}</div>
                            <div className='new-filter__filter-section'>
                                <div className={`filter-list ${shouldShowMoreRefiners ? 'filter-more' : 'filter-less'}`}>
                                    {endingRefinersToShow?.map((submenu, index) => (
                                        <React.Fragment key={index}>{submenu}</React.Fragment>
                                    ))}
                                </div>
                                {endingRefiners && endingRefiners.length > 5 && (
                                    <Button
                                        className={`more-filters-btn ${shouldShowMoreRefiners ? 'filter-minus' : 'filter-plus'}`}
                                        onClick={() => {
                                            setShouldShowMoreRefiners(!shouldShowMoreRefiners);
                                            if (viewProps.onMoreFiltersClicked) {
                                                viewProps.onMoreFiltersClicked(undefined, false, true);
                                            }
                                        }}
                                    >
                                        {shouldShowMoreRefiners ? 'Less filters' : 'More filters'}

                                        <span className='icon'></span>
                                    </Button>
                                )}
                            </div>
                        </Node>
                    </div>
                </Node>
            </>
        );
    }
    return null;
};

const renderSort = (props: ISortByViewProps): JSX.Element | null => {
    const { SortingContainer, sortByDropDown } = props;
    if (sortByDropDown) {
        return <Node {...SortingContainer}>{sortByDropDown}</Node>;
    }
    return null;
};

// const renderOOSBtn = (props: ISearchResultContainerViewProps) : JSX.Element | null => {
//     return (
//         <Node className=''>
//             {outOfStock}
//         </Node>
//     )
// }

// const renderOutOfStockBtn = (props: ISearchResultContainerViewProps): JSX.Element | null => {
//     const {showOutOfStock,hideOutOfStock, outOfStockStatus, isMobile, resources} = props;
//     return (
//         <Node className={isMobile ? 'out-of-stock-mob-container' : 'out-of-stock-container'}>
//             <p className='out-of-stock-text'>{resources.outOfStockNavText}</p>
//             <Node className='out-of-stock-btn-container'>
//                 <button className={outOfStockStatus ? 'out-of-stock-active' : 'out-of-stock-hide'}  onClick={showOutOfStock}>{resources.showOutofStockBtn}</button>
//                 <button className={!outOfStockStatus ? 'out-of-stock-active' : 'out-of-stock-hide'} onClick={hideOutOfStock}>{resources.hideOutOfStockBtn}</button>
//             </Node>
//             {/* <button onClick={toggleOutOfStock}>Out Of Stock</button> */}
//         </Node>
//     )
// }

const renderCategoryHierarchy = (props: ICategoryHierarchyViewProps): JSX.Element | null => {
    const { CategoryHierarchyContainer, categoryHierarchyList, categoryHierarchySeparator } = props;
    if (categoryHierarchyList) {
        return (
            <Node {...CategoryHierarchyContainer}>
                {categoryHierarchyList.map((category, index) => (
                    <React.Fragment key={index}>
                        {category}
                        {categoryHierarchyList && categoryHierarchyList[index + 1] && categoryHierarchySeparator}
                    </React.Fragment>
                ))}
            </Node>
        );
    }

    return null;
};

const renderTitleAndProductCount = (props: ITitleViewProps, srcProps: ISearchResultContainerViewProps): JSX.Element | null => {
    const { title, TitleContainer } = props;
    const isSearchPage = srcProps.context.request.query?.q;
    if (title) {
        return (
            <Node {...TitleContainer}>
                {isSearchPage ? (
                    <h2>
                        {title.titlePrefix} {title.titleText} - {title.titleCount}
                    </h2>
                ) : (
                    <h1>{title.titleText}</h1>
                )}
            </Node>
        );
    }
    return null;
};

export default SearchResultContainerView;
